module.exports = __webpack_public_path__ + "static/media/docx-file.c2c0caba.png";